import { api } from './client'

// Source-agnostic wearable reads. Used by the Signal Timeline day-
// detail screen to compute today's HRV / Sleep / Resting HR delta
// against the surrounding 30-day window. Provider-specific endpoints
// (Oura OAuth, sync) still live under api/oura.js.
export const wearablesApi = {
  range: (start, end, token) => {
    const params = new URLSearchParams({ start, end });
    return api.get(`/wearables/range?${params.toString()}`, token);
  },
  // Server-derived connection state for every provider. This is the
  // authority for "is X connected" — Oura from its OAuth token row,
  // Apple Health from data actually ingested. Returns
  // { providers: [{ key, label, connected, last_synced_date }] }.
  status: (token) => api.get('/wearables/status', token),
}
